export const state = {
  selectedItem: null,
  selectedImage: null,
  notifyModalContext: null,
  continueRoute: null,
};

export const getters = {};

export const mutations = {
  setSelectedItem(state, value) {
    state.selectedItem = value;
  },
  setSelectedImage(state, value) {
    state.selectedImage = value;
  },
  setNotifyModalContext(state, value) {
    state.notifyModalContext = value;
  },
  setContinueRoute(state, value) {
    state.continueRoute = value;
  },
};

export const actions = {};
